import dynamic from 'next/dynamic';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
const Header = dynamic(() => import('../../features/profile/modernHeader'));
const PiratesFilter = dynamic(() => import('../../features/filters/piratesFilter'));
const FilterModifier = dynamic(() => import('../../features/filters/filterModifier'));
const PiratesFetcher = dynamic(() => import('../../features/pirates/PiratesFetcher'));
const ModalLayout = dynamic(() => import('../../features/pirates/modal/ModalLayout'));
import { useProfile } from '../../features/providers/profile/index';
import MainPirateCard from '../../features/pirateCards/main';
import { Row, Col } from 'antd';
import * as Boxes from '../../components/styles/blocks';
const NothingFoundGallery = dynamic(() => import('../../features/pirates/nothingFound/gallery'));

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

function Galley(props) {
  const { profile } = useProfile();
  return (
    <ModalLayout {...props}>

      {/* Account profile header */}
      <Header profile={profile} />

      {/* Sidebar filters */}
      <PiratesFilter profile={profile} enableStatus allowAddressSearch>
        {(filters, removeFilter, _, isFilterClosed, __, tokensIds, setAddress) => (

          // Search bar + Sorting + Blockchain
          <FilterModifier {...{ filters, removeFilter, setAddress }} pirateIds={tokensIds} hideReload allowAddressSearch>
            {(filterModifiers) => {
              const viewFilters = {...filters, ...filterModifiers};                      
              return <PiratesFetcher filters={viewFilters} pirateIds={tokensIds}>
                {(pirates, onPirateClick) => {
                  
                  if (!pirates.length) return <NothingFoundGallery />

                  return (
                    <Row 
                      className="pirate-list"
                      gutter={[20,20]}
                      style={{width: "100%", marginLeft:0, marginRight: 0 }}
                    >
                      {
                        pirates.map((pirate, index) => (
                          <Col key={index} xl={isFilterClosed ? 6 : 8} lg={12} md={12} sm={12} style={{width: '100%'}}>
                            <Boxes.Block marginB="0px">
                              <MainPirateCard pirate={{ ...pirate, index }} blockchain={viewFilters.blockchain} onClick={onPirateClick} />
                            </Boxes.Block>
                          </Col>
                        ))
                      }    
                    </Row>
                  )
                }}
              </PiratesFetcher>
            }}
          </FilterModifier>
        )}
      </PiratesFilter>    

    </ModalLayout>
  );
}

export default Galley;
